import { segmentsApi } from "@/react/api/segmentsApi";
import type { CommunitySegmentRule } from "../generated/WorkflowsApi.types";

interface UpsertSegmentAttributes {
  community_segment_id?: string | number | null;
  rules: CommunitySegmentRule;
}

export const upsertSegment = (attributes: UpsertSegmentAttributes) => {
  const { rules, community_segment_id: communitySegmentId } = attributes;

  if (communitySegmentId) {
    return segmentsApi.update({ id: Number(communitySegmentId), rules });
  }

  return segmentsApi.create({
    rules,
    visible: false,
  });
};
